import Alpine from 'alpinejs';

class FormFieldHandler {
    showPassword: boolean = false;
    $el: HTMLElement;

    toggleShowPassword() {
        this.showPassword = !this.showPassword;

        const parentElement = this.$el.parentElement;
        if (!parentElement) return;

        const inputField = parentElement.querySelector('input');
        if (!inputField) return;

        inputField.type = this.showPassword ? 'text' : 'password';
        this.$el.querySelector('#show-pw').classList.toggle('hidden');
        this.$el.querySelector('#hide-pw').classList.toggle('hidden');
    }
}

Alpine.data('formFieldHandler', () => new FormFieldHandler());
